'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style", "id", "rowTypes", "rowsPerType"];
import * as React from 'react';
import { useId } from '@base-ui/utils/useId';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { DEFAULT_ROW_TYPES } from "../../internals/utils/getNavigationTarget.mjs";
import { CalendarGridRootContext } from "./CalendarGridRootContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_ROWS_PER_TYPE = {};
export const CalendarGridRoot = /*#__PURE__*/React.forwardRef(function CalendarGridRoot(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      id: idProp,
      rowTypes = DEFAULT_ROW_TYPES,
      rowsPerType: rowsPerTypeProp = DEFAULT_ROWS_PER_TYPE
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const id = useId(idProp);
  const rowsPerType = rowsPerTypeProp;
  const rootRef = React.useRef(null);
  const [focusedCell, setFocusedCellState] = React.useState(null);
  const setFocusedCell = React.useCallback(coordinates => {
    setFocusedCellState(prev => prev?.rowType === coordinates.rowType && prev.rowIndex === coordinates.rowIndex && prev.columnIndex === coordinates.columnIndex ? prev : coordinates);
  }, []);
  const handleBlur = React.useCallback(event => {
    if (!rootRef.current?.contains(event.relatedTarget)) {
      setFocusedCellState(null);
    }
  }, []);
  const contextValue = React.useMemo(() => ({
    id,
    focusedCell,
    setFocusedCell,
    rowTypes,
    rowsPerType
  }), [id, focusedCell, setFocusedCell, rowTypes, rowsPerType]);
  const element = useRenderElement('div', componentProps, {
    ref: [forwardedRef, rootRef],
    props: [elementProps, {
      role: 'grid',
      id,
      onBlur: handleBlur
    }]
  });
  return /*#__PURE__*/_jsx(CalendarGridRootContext.Provider, {
    value: contextValue,
    children: element
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridRoot.displayName = "CalendarGridRoot";